module.exports = __webpack_public_path__ + "img/wa_example_dropdown.808d3d3f.png";